<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">Shipping & Delivery</h3>
    <div class="informationBox">
      <ul class="useragreement">
        <li>
          <div class="t1">Shipping</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Shipping from Germany</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">Delivery times:</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Germany: 2–5 business days</li>
              <li>EU: 3–10 business days</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">Shipping costs:</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Shown at checkout</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">Customs:</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Additional charges may apply outside EU </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";
.agreementList li{
  list-style: inside;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/shippingagreement.vue